import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, Headphones, Shield } from 'lucide-react';

export function About() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('home.about.title')}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('home.about.description')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <Clock className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">{t('home.about.monitoring.title')}</h3>
            <p className="text-gray-600">{t('home.about.monitoring.description')}</p>
          </div>
          <div className="text-center">
            <Headphones className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">{t('home.about.support.title')}</h3>
            <p className="text-gray-600">{t('home.about.support.description')}</p>
          </div>
          <div className="text-center">
            <Shield className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2">{t('home.about.network.title')}</h3>
            <p className="text-gray-600">{t('home.about.network.description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}